import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import React, { useContext, useState } from 'react'
import PrimaryButton from '../../../../../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../../../../../global/components/buttons/secondary-button/SecondaryButton'
import styles from '../styles/styles.module.css'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { fetchData } from '../../../../../../../global/utils/fetch'
import { forceAppointment, getRoutes } from './api'
import useFetch from '../../../../../../../global/hooks/useFetchHook'
import { useParams } from 'react-router-dom'
import { WoDetailContext } from '../../../../../context/context'
import { ToastNotificationContext } from '../../../../../../../global/context/toast-context/ToastNotificationContext'

interface IForceAppointmentProps {
  handleClose: Function
}
interface IForceAppFormDataProps {
  routeObjectId: string
  orderObjectId: string
  routeInstructionTime: number | null
}

export default function ForceAppointment(props: IForceAppointmentProps) {
  const { user } = useAuthenticator((context) => [context.user])
  const { id } = useParams()
  const { queryOrderData } = useContext(WoDetailContext)
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)
  const { data: order } = useContext(WoDetailContext)

  const [isChecked, setIsChecked] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState<IForceAppFormDataProps>({
    routeObjectId: '',
    orderObjectId: id ?? '',
    routeInstructionTime: null,
  })

  const { data } = useFetch(getRoutes(order.location?.objectId))

  const handleForceAppointment = async () => {
    const orderId = id ?? ''
    try {
      setIsLoading(true)
      await fetchData<void>(forceAppointment(formData))
      await queryOrderData(orderId)
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'Successfully forced appointment!',
        severity: 'success',
      })
    } catch (err) {
      console.error(err)
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'Error with force appointment!',
        severity: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }
  const handleFormChange = (e: any) => {
    const { value, name } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  return (
    <div className={styles.inputsContainer}>
      <div className={styles.topInputsContainer}>
        <RouteDropDown
          data={data}
          val={formData.routeObjectId}
          handleChange={handleFormChange}
        />
      </div>
      <div className={styles.topInputsContainer}>
        <TextField
          type='time'
          name='routeInstructionTime'
          onChange={handleFormChange}
        />
      </div>
      <div className={styles.checkBoxContainer}>
        <Checkbox onChange={() => setIsChecked(!isChecked)} />
        <div>Yes I want to force this work order to this route</div>
      </div>
      <div className={styles.buttonContainer}>
        <SecondaryButton
          buttonName='Cancel'
          onClick={() => props.handleClose()}
        />
        <PrimaryButton
          buttonName='Force'
          disabled={!isChecked || isLoading}
          onClick={handleForceAppointment}
        />
      </div>
    </div>
  )
}
const RouteDropDown = ({ data, handleChange, val }: any) => {
  if (!data) {
    return <div>Loading...</div>
  }

  let menuItems = data.map((route: any, index: number) => {
    const { technician } = route

    let technicianName = technician ? technician.name : 'No technician'

    return (
      <MenuItem
        key={index}
        value={route.objectId}
      >
        {`${route.dayFormatted} - ${technicianName}`}
      </MenuItem>
    )
  })

  return (
    <TextField
      fullWidth
      label='Route'
      name='routeObjectId'
      select
      value={val}
      onChange={handleChange}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 500,
              width: 200,
            },
          },
        },
      }}
    >
      {menuItems}
    </TextField>
  )
}
